<template>
  <div class="content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户管理" name="two" v-if="$utils.checkPer('user.index')">
        <el-row style="padding-bottom: 20px">
          <el-col>
            <el-button
              style="float: left"
              type="primary"
              @click="addUser"
              v-if="$utils.checkPer('user.store')"
              >添加账号</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataTable"
          style="width: 100%"
          min-height="300"
          size="mini"
        >
          <el-table-column prop="id" label="序号"> </el-table-column>
          <el-table-column prop="name" label="登录帐号"> </el-table-column>
          <el-table-column prop="username" label="用户姓名"> </el-table-column>
          <el-table-column prop="phone" label="联系方式"> </el-table-column>
          <el-table-column label="角色">
            <template slot-scope="scope">
              <span>{{ id2Role(scope.row.role_id) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag type="success" v-show="scope.row.state == 1">启用</el-tag>
              <el-tag type="danger" v-show="scope.row.state == 2">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                v-if="$utils.checkPer('user.update')"
                @click="edit(scope.row)"
                type="text"
                size="small"
                >修改
              </el-button>
              <el-button
                v-if="$utils.checkPer('user.destroy')"
                @click="del(scope.row)"
                type="text"
                size="small"
                v-show="scope.row.state == 1 && scope.row.name != 'admin'"
              >
                停用帐号
              </el-button>

              <el-button
                v-if="$utils.checkPer('user.destroy')"
                @click="del(scope.row)"
                type="text"
                size="small"
                v-show="scope.row.state == 2"
              >
                启用帐号
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 编辑 添加未完成 -->
      <el-tab-pane label="角色管理" name="role" v-if="$utils.checkPer('role.index')">
        <el-row style="padding-bottom: 20px">
          <el-col>
            <el-button
              style="float: left"
              type="primary"
              @click="addJs"
              v-if="$utils.checkPer('role.store')"
            >
              添加角色
            </el-button>
          </el-col>
        </el-row>
        <el-table
          :data="roleTable"
          style="width: 100%"
          min-height="300"
          size="mini"
        >
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column label="权限">
            <template slot-scope="scope">
              <el-popover
                placement="left-start"
                title="所有权限"
                size="mini"
                trigger="click"
                :content="getPer(scope.row.auth_permissions)"
              >
                <el-button slot="reference">查看权限</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <div v-html="scope.row.remark"></div>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column prop="updated_at" label="更新时间">
          </el-table-column>
          <el-table-column label="是否启用">
            <template slot-scope="scope">
              <el-tag type="success" v-show="scope.row.state == 1">启用</el-tag>
              <el-tag type="danger" v-show="scope.row.state == 2">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                v-if="$utils.checkPer('role.update')"
                @click="editJs(scope.row)"
                type="text"
                size="small"
              >
                修改
              </el-button>
              <el-button
                v-if="$utils.checkPer('role.destroy')"
                @click="delJs(scope.row)"
                type="text"
                size="small"
                v-show="scope.row.state == 1"
                :disabled="scope.row.id == 1"
              >
                禁用角色
              </el-button>
              <el-button
                v-if="$utils.checkPer('role.destroy')"
                @click="delJs(scope.row)"
                type="text"
                size="small"
                v-show="scope.row.state == 2"
                :disabled="scope.row.id == 1"
              >
                启用角色
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane
        label="权限管理"
        name="permission"
        v-if="$utils.checkPer('permission.index')"
      >
        <el-row style="padding-bottom: 20px">
          <el-col>
            <el-button
              style="float: left"
              type="primary"
              @click="addQx"
              v-if="$utils.checkPer('permission.store')"
            >
              添加权限
            </el-button>
            <span
              style="
                float: left;
                margin-top: 20px;
                margin-left: 18px;
                font-size: 14px;
                color: #777777;
              "
            >
              提示：<span style="color: red">非专业人员请勿操作此页内容</span>
            </span>
          </el-col>
        </el-row>
        <el-table
          :data="permissionTable"
          style="width: 100%"
          min-height="300"
          size="mini"
        >
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="path" label="路由"> </el-table-column>
          <el-table-column prop="pid" label="父节点">
            <template slot-scope="scope">
              <div v-html="getPerName(scope.row)"></div>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序"> </el-table-column>
          <el-table-column prop="remark" label="注释"> </el-table-column>
          <el-table-column label="是否启用">
            <template slot-scope="scope">
              <el-tag type="success" v-show="scope.row.state == 1">启用</el-tag>
              <el-tag type="danger" v-show="scope.row.state == 2">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                v-if="$utils.checkPer('permission.update')"
                @click="editQx(scope.row)"
                type="text"
                size="small"
                :disabled="scope.row.id == 1"
              >
                修改
              </el-button>
              <el-button
                v-if="$utils.checkPer('permission.destroy')"
                @click="delQx(scope.row)"
                type="text"
                size="small"
                v-show="scope.row.state == 1"
                :disabled="scope.row.id == 1"
              >
                禁用权限
              </el-button>
              <el-button
                v-if="$utils.checkPer('permission.destroy')"
                @click="delQx(scope.row)"
                type="text"
                size="small"
                v-show="scope.row.state == 2"
                :disabled="scope.row.id == 1"
              >
                启用权限
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="账号信息" name="one">
        <el-row>
          <el-col :span="2" class="key">姓名：</el-col>
          <el-col :span="10" :offset="1" class="value">{{ user.name }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="key">登录名：</el-col>
          <el-col :span="5" :offset="1" class="value">{{ user.username }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="key">权限：</el-col>
          <el-col :span="30" :offset="1" class="value">{{ user.phone }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="key">注册时间：</el-col>
          <el-col :span="5" :offset="1" class="value">{{ user.created_at }}</el-col>
        </el-row>
      </el-tab-pane>

      <!-- 添加用户 -->
      <el-dialog
        title="用户操作"
        v-if="dialogVisibleUser"
        :visible.sync="dialogVisibleUser"
        width="50%"
        :before-close="handleClose"
      >
        <myUser
          @userEmit="onuserEmit"
          :roleList="role"
          :editrow="usermodifyrow"
        ></myUser>
      </el-dialog>
      <!-- 添加角色 -->
      <el-dialog
        title="角色操作"
        v-if="dialogVisibleRole"
        :visible.sync="dialogVisibleRole"
        width="70%"
        :before-close="handleClose"
      >
        <myRole
          @roleEmit="onroleEmit"
          :per="permissionTable"
          :isedit="rolemodifyrow"
        ></myRole>
      </el-dialog>
      <!-- 添加权限 -->
      <el-dialog
        title="权限操作"
        v-if="dialogVisiblePermission"
        :visible.sync="dialogVisiblePermission"
        width="50%"
        :before-close="handleClose"
      >
        <myPermission
          @permissionEmit="onPermissionEmit"
          :permission="permissionTable"
          :edit="Permissionmodify"
        ></myPermission>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import myUser from "./user";
import myPermission from "./permission";
import myRole from "./role";
import {
  getUserList,
  stopUser,
  onaddUser,
  getRoleLise,
  modifyUser,
  modifyRole,
  stopRole,
  addRole,
  getPermissionList,
  addPermission,
  modifyPermission,
  stopPermission,
} from "../../api/api";
export default {
  name: "account-management",
  data() {
    return {
      activeName: "two",
      dataTable: [],
      user: {},
      //角色表
      role: [],
      zdTable: [],
      permissionTable: [], // 权限列表
      roleTable: [],
      rolePer: [],
      hospital: [],
      loading: false, // loding状态
      dialogVisibleUser: false, // 添加编辑用户
      dialogVisibleRole: false, // 添加编辑角色
      dialogVisiblePermission: false, // 添加权限
      ismodify: 0, // 判断用户是否为编辑
      isrolemodify: 0, // 判断角色是否为编辑
      isPermission: 0, // 判断权限是否为编辑
      userid: "", // 修改当前用户的id
      roleid: "", // 修改当前角色的id
      Permissionid: "", // 修改当前权限的id
      usermodifyrow: "", // 修改当前行数据
      rolemodifyrow: "", // 修改当前行数据
      Permissionmodify: "", // 修改当前行数据
    };
  },
  components: {
    myUser,
    myRole,
    myPermission,
  },
  mounted() {
    this.getList();
    this.getRole();
    this.getPermissionList();
    this.user = JSON.parse(window.localStorage.getItem("user"));
  },
  methods: {
    // 用户列表
    getList() {
      getUserList().then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.dataTable = data;
      });
    },
    id2Role(id) {
      for (let i = 0; i < this.role.length; ++i) {
        if (this.role[i].id == id) {
          return this.role[i].name;
        }
      }
    },
    // 展示权限列表
    getPermissionList() {
      // 展示权限列表
      getPermissionList().then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.permissionTable = data;
      });
    },
    getPerName(row) {
      let pid = row.pid;
      let list = this.permissionTable;
      for (let index in list) {
        if (list[index].id == pid) {
          return list[index].name;
        }
      }
    },
    // 添加用户
    addUser() {
      this.dialogVisibleUser = true;
    },
    // 添加用户子组件传递的值
    onuserEmit(obj) {
      if (obj.form) {
        if (this.ismodify == 0) {
          onaddUser(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.ismodify == 1) {
          modifyUser(this.userid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
          this.ismodify = 0;
        }
      }
      this.usermodifyrow = "";
      this.getList();
      this.dialogVisibleUser = false;
    },
    // 用户信息编辑
    edit(row) {
      this.userid = row.id;
      this.usermodifyrow = row;
      this.ismodify = 1;
      this.dialogVisibleUser = true;
    },
    // 用户停用账号
    del(row) {
      stopUser(row.id).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        this.$message.success(data.msg);
        this.getList();
      });
    },
    //添加权限
    addQx() {
      this.dialogVisiblePermission = true;
    },
    onPermissionEmit(obj) {
      if (obj.form) {
        if (this.isPermission == 0) {
          addPermission(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.isPermission == 1) {
          modifyPermission(this.Permissionid,obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
          this.isPermission = 0;
        }
      }
      this.Permissionmodify = "";
      this.getPermissionList();
      this.dialogVisiblePermission = false;
    },
    //修改权限
    editQx(row) {
      this.Permissionmodify = row;
      this.isPermission = 1;
      this.Permissionid = row.id;
      this.dialogVisiblePermission = true;
    },
    //禁用权限
    delQx(row) {
      stopPermission(row.id).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        if (data.code == 200) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
        this.getPermissionList();
      });
    },
    // 获取角色
    getRole() {
      getRoleLise().then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.role = data;
        this.roleTable = data;
      });
    },
    //添加角色
    addJs() {
      this.Permissionmodify = {};
      this.Permissionid = "";
      this.dialogVisibleRole = true;
    },
    onroleEmit(obj) {
      if (obj.form) {
        if (this.isrolemodify == 0) {
          console.log(obj);
          addRole(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.isrolemodify == 1) {
          modifyRole(this.roleid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
            this.isrolemodify = 0;
          });
        }
      } else {
        console.log("取消");
      }
      this.getRole();
      this.rolemodifyrow = "";
      this.dialogVisibleRole = false;
    },
    //修改角色
    editJs(row) {
      console.log("row",row);
      this.roleid = row.id;
      this.rolemodifyrow = row;
      this.isrolemodify = 1;
      this.dialogVisibleRole = true;
    },
    //停用角色
    delJs(row) {
      stopRole(row.id).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        if (data.code == 200) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
        this.getRole();
      });
    },
    timestampToTime(timestamp) {
      let Y, M, D, h, m, s;
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      Y = date.getFullYear() + "-";
      M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return Y + M + D + h + m;
    },
    getPer(data) {
      let str = "";
      for (let i = 0; i < data.length; ++i) {
        str += data[i].name + ",";
      }
      return str.substr(0, str.length - 1) || "暂无权限";
    },
    handleClick(tab, event) {
      let name = tab.name;
      this.loading = true;
      switch (name) {
        case "two":
          //用户
          this.getList();
          break;
        case "three":
          //字典
          this.getZd();
          break;
        case "permission":
          //权限
          this.getPermissionList();
          break;
        case "role":
          //角色
          this.getRole();
          break;
        default:
          this.loading = false;
          break;
      }
    },
    handleClose() {
      this.dialogVisibleUser = false;
      this.dialogVisibleRole = false;
      this.dialogVisiblePermission = false;
    },
  },
};
</script>

<style scoped lang="scss">
.el-tabs {
  margin-top: 20px;
}
</style>